import React, { useEffect, useState } from 'react';
import api from '../../lib/axios';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { setAppBackground } from '../../redux/slices/layoutSlice';
import { useDispatch } from 'react-redux';
import createTranslateFunction from '../../i18n/createTranslateFunction';
import { AppDispatch } from '../../redux/store';
import { useNavigate } from 'react-router-dom';
import { Loading } from '../../components/Loading';
import { trackLastOrder } from '../../redux/slices/ordersSlice';

type TrackOrderLoadingScreenProps = {
    focusKey: string;
    orderId: string;
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
};
const TrackOrderLoadingScreen = ({
    focusKey: focusKeyParam,
    orderId,
    setIsLoading,
}: TrackOrderLoadingScreenProps) => {
    const trackOrderLoadingTranslateFunction = createTranslateFunction('buttons');
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const [failedAttempts, setFailedAttempts] = useState(0);
    const { ref, focusKey, focusSelf } = useFocusable({
        focusKey: focusKeyParam,
    });

    //This function is called to check if Atmos already changed the order status to complete. if so, change the loading state.
    //Once the order status is complete, the loading screen will be removed and the trackOrderScreen will be shown.
    const fetchOrderStatusFromDB = async () => {
        try {
            const response = await api.get(`/order/${orderId}/status`);
            console.log(response.data, 'This is the response from the order status');
            return response.data;
        } catch (error) {
            console.error('Error fetching order status:', error);
            setFailedAttempts((prev) => prev + 1);
            if (failedAttempts >= 3) {
                //Navigate to the homepage and maybe display error
                navigate('/');
            }
        }
    };

    useEffect(() => {
        focusSelf();
        dispatch(
            setAppBackground([
                'https://pizzahut-assets.s3.amazonaws.com/screen-bg/screens/tracking-page/Track_Order_Background.png',
                '',
            ]),
        );
    }, []);

    useEffect(() => {
        const fetchingStatusInterval = setInterval(async () => {
            const orderStatus = await fetchOrderStatusFromDB();

            if (orderStatus === 'complete') {
                dispatch(trackLastOrder()).unwrap();
                clearInterval(fetchingStatusInterval);
                setIsLoading(false);
            }
        }, 5000); // poll status from DB every 5 seconds

        return () => clearInterval(fetchingStatusInterval);
    }, [orderId, dispatch]);

    return (
        <FocusContext.Provider value={focusKey}>
            <div
                ref={ref}
                className="relative flex-col w-full h-full flex items-center justify-evenly"
            >
                <div className="animate-breathing flex flex-col items-center justify-center">
                    <span className="text-[3.5vw]">הזמנתכם התקבלה בהצלחה, ונכנסת כעת למערכת</span>
                    <span className="text-[3vw]">זה יקח רק כמה שניות...</span>
                </div>
                <div className='w-full h-["70%"] flex justify-center items-center'>
                    <Loading className="bg-transparent" />
                </div>
            </div>
        </FocusContext.Provider>
    );
};

export default TrackOrderLoadingScreen;
